"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomNavigationNavigator = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const react_1 = tslib_1.__importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const components_2 = require("../../components");
const helpers_1 = require("../../helpers");
const BottomNavigationNavigator = (props) => {
    const { children, routes } = props;
    // Extract Contexts
    const { theme } = core_1.useTheme();
    const location = react_router_dom_1.useLocation();
    const { navigator: mainNavigator } = react_1.useContext(components_2.MainNavigatorContext);
    const navigation = core_1.useNavigation();
    const screenProps = helpers_1.useScreenProps();
    // Options
    const baseOptions = {
        activeBackgroundColor: theme.palette.background.card,
        activeTintColor: theme.palette.primary.main,
        inactiveBackgroundColor: theme.palette.background.card,
        inactiveTintColor: theme.palette.text.secondary,
        showIcon: true,
        showLabel: true,
        labelStyle: {},
        tabStyle: {},
    };
    const tabBarOptions = core_1.merge(baseOptions, props.tabBarOptions || {});
    // Resolve active tab index
    const currentIndex = routes.findIndex((route) => route.path === location.pathname);
    // onChange listener
    const onChange = (_e, i) => {
        navigation.push(routes[i].name, navigation.state.params);
    };
    // Render single tab
    const renderTab = (route, index) => {
        const options = helpers_1.resolveRouteOptions(route, props, mainNavigator, {
            navigation,
            screenProps,
            route: Object.assign(Object.assign({}, route), { params: navigation.state.params }),
        });
        const icon = helpers_1.getIcon(core_1.merge(Object.assign({ headerTitle: route.name }, options), { tabBarOptions }), index === currentIndex, theme);
        const title = helpers_1.getTitle(core_1.merge(Object.assign({ headerTitle: route.name }, options), { tabBarOptions }), index === currentIndex, theme);
        return react_1.default.createElement(components_1.BottomNavigationAction, { icon: icon, label: title, value: index, key: index });
    };
    return (react_1.default.createElement(components_1.View, { style: {
            backgroundColor: theme.palette.background.default,
            flex: 1,
        } },
        react_1.default.createElement(components_1.View, { style: { flex: 1 } }, children),
        react_1.default.createElement(components_1.BottomNavigation, { value: currentIndex > -1 ? currentIndex : 0, onChange: onChange, style: Object.assign({ zIndex: 1100 }, tabBarOptions.style) }, routes.map(renderTab))));
};
exports.BottomNavigationNavigator = BottomNavigationNavigator;
exports.BottomNavigationNavigator.displayName = 'BottomNavigationNavigator';
